import React, { useEffect } from 'react'
import { Stack } from '@mui/material'
import { useBoolean } from 'ahooks'
import { useAtom } from 'jotai'
import Halo from '../../Halo'
import { LeftWrapper, Text1 } from '../styleds'
import Header from '../../Header'
import PendingHistory from './PendingHistory'
import GoToWithdraw from './GoToWithdraw'
import TransferButton from './TransferButton'
import Check from './Check'
import GoToHdWallet from './GoToHdWallet'

import { useBtc } from '@/context/BtcContext'
import AssetSelect from '@/components/common/AssetSelect2'
import BtcSelect from '@/components/common/BtcSelect'
import NetworkSelect from '@/components/common/NetworkSelect'
import useQueryToken from '@/hooks/useQueryToken'
import { TargetChainAtom, TickerAtom } from '@/components/common/atoms'
import { TICKERS_FILTER_BY_CHAIN } from '@/constants/token'

const DepositLeft = () => {
  const { isConnected } = useBtc()

  const [isChecked, { toggle: toggleChecked }] = useBoolean()

  const [targetChain, setTargetChain] = useAtom(TargetChainAtom)
  const [ticker, setTicker] = useAtom(TickerAtom)

  useQueryToken((ticker) => {
    setTicker(ticker)
  })

  useEffect(() => {
    if (!TICKERS_FILTER_BY_CHAIN[targetChain].find((option) => option.name === ticker)) {
      setTicker(TICKERS_FILTER_BY_CHAIN[targetChain][0].name)
    }
  }, [setTicker, targetChain, ticker])

  return (
    <LeftWrapper>
      <Stack spacing={32} sx={{ width: '100%', alignItems: 'center' }}>
        <Header />

        <Halo />

        <BtcSelect tag="From" />

        <GoToWithdraw />

        <Stack direction={{ xs: 'column', md: 'row' }} spacing={20} width="100%">
          <NetworkSelect
            tag="To"
            value={targetChain}
            onChange={(event) => {
              if (typeof event.target.value === 'number') {
                setTargetChain(event.target.value)
              }
            }}
          />

          <AssetSelect mode="btc" />
        </Stack>

        <Check value={isChecked} toggle={toggleChecked} />

        <TransferButton ticker={ticker} disabled={!isChecked} />

        <Text1 sx={{ textAlign: 'center' }}>Estimated 3 blocks to confirm.</Text1>

        {isConnected ? <PendingHistory /> : <GoToHdWallet />}
      </Stack>
    </LeftWrapper>
  )
}

export default DepositLeft
